import React, { useState } from 'react';
import { usefulLinksData } from '../data/usefulLinks';
import { X, ChevronDown } from 'lucide-react';

const LinksPanel = ({ isOpen, onClose }) => {
  const [openCategory, setOpenCategory] = useState(null);

  const handleCategoryClick = (category) => {
    if (openCategory === category) {
      setOpenCategory(null);
    } else {
      setOpenCategory(category);
    }
  };

  if (!isOpen) return null;

  return (
    <>
      <div 
        className="fixed inset-0 bg-black/40 z-40" 
        onClick={onClose} 
      />
      
      <div className="fixed top-0 right-0 h-full w-80 shadow-2xl shadow-black/50 z-50 flex flex-col"
        style={{ backgroundColor: 'var(--bg-surface)', borderLeft: '1px solid var(--border-primary)' }}>
        <div className="flex items-center justify-between p-4" style={{ borderBottom: '1px solid var(--border-primary)' }}>
          <h2 className="text-xs font-semibold uppercase tracking-widest" style={{ color: 'var(--text-faint)' }}>Useful Links</h2>
          <button onClick={onClose} className="p-1.5 rounded-lg transition-all duration-150" style={{ color: 'var(--text-faint)' }} title="Close">
            <X size={16} />
          </button>
        </div>
        
        <div className="flex-1 overflow-y-auto custom-scrollbar p-3 space-y-1.5">
          {usefulLinksData.map((item) => (
            <div key={item.category} className="rounded-xl overflow-hidden" style={{ border: '1px solid var(--border-primary)', backgroundColor: 'var(--bg-elevated)' }}>
              <button
                className="w-full flex items-center justify-between px-4 py-2.5 transition-colors duration-150"
                onClick={() => handleCategoryClick(item.category)}
              >
                <span className="text-[13px] font-medium" style={{ color: 'var(--text-secondary)' }}>{item.category}</span>
                <ChevronDown size={14} className={`transition-transform duration-200 ${openCategory === item.category ? 'rotate-180' : ''}`} style={{ color: 'var(--text-faint)' }} />
              </button>
              
              {openCategory === item.category && (
                <ul className="px-3 pb-2 space-y-0.5 pt-1" style={{ borderTop: '1px solid var(--border-primary)' }}>
                  {item.links.map((link) => (
                    <li key={link.name}>
                      <a 
                        href={link.url} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        referrerPolicy="no-referrer"
                        className="text-[13px] hover:text-indigo-300 transition-colors duration-150 block py-1.5 px-2 rounded-md hover:bg-indigo-500/[0.05]"
                        style={{ color: 'var(--text-muted)' }}
                      >
                        {link.name}
                      </a>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default LinksPanel;